
export const pluralize   = ( n: number, singular: string, plural: string ) => n == 1 ? singular : plural;
export const yieldSpace  = ( a: string, b: string ) => a.length > 0 && b.length > 0 ? " " : ""; 
export const concatWords = ( ...words: string[] ) => words.reduce( (a, b) => `${a}${yieldSpace( a, b )}${b}` , "" )